import {DataObject} from "../dataObject";
import FirebaseRead from "@/services/database/firebaseRead";


export class SpielerPrivate extends DataObject {
    constructor() {
        super();
        this.id = '';
        this.strasse = '';
        this.plz = '';
        this.ort = '';
        this.telefon = '';
        this.mobilTelefon = '';
        this.geburtsdatum = '';
        this.eMail = '';
        this.geburtsort = '';
        this.nationalitaet = 'AUT';
        // local
        this.local.definitions.databaseHandlerCall = 'spielerPrivate';
    }
    async loadFromDatabase(spielerId){
        const dataObject = await FirebaseRead.readSingleDoc(
            'spieler/' + spielerId + '/private', spielerId)
        this.setFromDataObject(dataObject)
    }
}